import { useEffect } from 'react'
import { supabase } from '@/lib/supabase/client'

interface UseRealtimeGearNeedsProps {
  tripId: string
  enabled: boolean
  onGearNeedsUpdate: () => void
}

export function useRealtimeGearNeeds({ tripId, enabled, onGearNeedsUpdate }: UseRealtimeGearNeedsProps) {
  useEffect(() => {
    if (!enabled || !tripId) return

    // Subscribe to gear needs changes
    const gearNeedsChannel = supabase
      .channel(`trip_gear_needs_${tripId}`)
      .on(
        'postgres_changes',
        {
          event: '*',
          schema: 'public',
          table: 'trip_gear_needs',
          filter: `trip_id=eq.${tripId}`
        },
        () => {
          onGearNeedsUpdate()
        }
      )
      .subscribe()

    // Subscribe to gear claims changes
    const gearClaimsChannel = supabase
      .channel(`trip_gear_claims_${tripId}`)
      .on(
        'postgres_changes',
        {
          event: '*',
          schema: 'public',
          table: 'trip_gear_claims'
        },
        (payload) => {
          // Check if this claim is related to our trip's gear needs
          if (payload.new && typeof payload.new === 'object' && 'gear_need_id' in payload.new) {
            // We need to check if this gear need belongs to our trip
            // For now, we'll refresh all gear needs to be safe
            onGearNeedsUpdate()
          }
        }
      )
      .subscribe()

    return () => {
      gearNeedsChannel.unsubscribe()
      gearClaimsChannel.unsubscribe()
    }
  }, [tripId, enabled, onGearNeedsUpdate])
}
